import InfoBox from './info-box';
import marker from './marker';
// import styles from './style';
//
// import Vue from 'vue';
// import { loaded } from 'vue2-google-maps';

// This was not working - but is low priority
// var settings = new Vue({
//   data: {
//     defaultMapOptions: {}
//   }
// });
//
// loaded.then(() => {
//   settings.defaultMapOptions = {
//     disableDefaultUI: true,
//     styles
//   };
// });

export default {
  InfoBox,
  marker,
  // settings
};
